import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './Cycle.scss';
import Price from '../../../Price';
import Selected from '../../../../icons/dist/components/selected';
import classNames from 'classnames';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import { isLocalCurrencyOnRight } from '../../../../services/window-utils';

export interface CycleProps extends WithTranslation, InjectedExperimentsProps {
  type: 'monthly' | 'yearly' | '2years';
  savePercentage?: number;
  saveTotalAmount?: number;
  selected: boolean;
  priceAmount: number;
  discountAmount?: number;
  priceCurrency: string;
  onSelectedCycle: Function;
  isEnabled: boolean;
}

class Cycle extends React.Component<CycleProps> {
  CYCLE_PREFIX = 'cycle.';

  render() {
    const {
      t,
      priceAmount,
      priceCurrency,
      type,
      savePercentage,
      saveTotalAmount,
      selected,
      onSelectedCycle,
      isEnabled,
      discountAmount,
      experiments,
    } = this.props;

    const isPackagePickerSavingAmountInsteadOfPercentageEnabled =
      experiments.enabled(
        'specs.ascend.PackagePickerTestShowSavingAmountInsteadOfPercentage',
      );

    const getFormattedSaveTotalAmount = () => {
      return isLocalCurrencyOnRight()
        ? `${saveTotalAmount}${priceCurrency}`
        : `${priceCurrency}${saveTotalAmount}`;
    };

    const saveDisplayValue =
      isPackagePickerSavingAmountInsteadOfPercentageEnabled
        ? t('packageCycleModal.saveTotalAmountAndCurrency', {
            saveTotalAmountAndCurrency: getFormattedSaveTotalAmount(),
          })
        : t('packageCycleModal.save', {
            savePercentage: String(savePercentage),
          });

    const shouldShowSaveCycle = savePercentage || saveTotalAmount;

    return (
      <div className={s.root} data-hook="cycle">
        <div className={s.saveArea}>
          {shouldShowSaveCycle && (
            <div
              className={classNames(s.save, {
                [s.selected]: selected,
                [s.disabled]: !isEnabled,
              })}
              data-hook="cycle-save"
            >
              {saveDisplayValue}
            </div>
          )}
        </div>
        <button
          data-hook="cycle-selection-area"
          className={classNames(s.mainCycleBox, {
            [s.selected]: selected,
            [s.disabled]: !isEnabled,
          })}
          onClick={() => isEnabled && onSelectedCycle()}
          tabIndex={0}
          aria-pressed="false"
          aria-label={`${this.CYCLE_PREFIX}${type}`}
        >
          <div className={s.selected}>
            {selected && <Selected size="20px" data-hook="cycle-selected" />}
          </div>
          <div className={s.title} data-hook="cycle-title">
            {t(`${this.CYCLE_PREFIX}${type}`)}
          </div>
          <div className={s.price} data-hook="cycle-price">
            <Price
              amount={priceAmount}
              currency={priceCurrency}
              narrowView={true}
              discountAmount={discountAmount}
            />
          </div>
        </button>
      </div>
    );
  }
}

export default withTranslation()(withExperiments(Cycle));
